@defer (when value()) {
  <app-user-form
    [(value)]="value"
    [edit]="true"
    [id]="id"
    [profile]="profile()"
    [access]="access()"
  ></app-user-form>
}
